import { randomIntFromChoices } from '~/bootcamp/Activities/utils/activities.utils'

import { range, shuffle } from '~/utils/helpers'

import { ActivityNames } from './types'
import { getRanges } from './constants'

export function selectRandomItem(arr: any[]): { index: number; val: any } {
  const randIndex = Math.floor(Math.random() * arr.length)
  return { index: randIndex, val: arr[randIndex] }
}

export function negateAndShuffle(arr: number[]): number[] {
  const terms: number[] = [...arr]
  const { index } = selectRandomItem(arr)
  return terms.map((item, i) => (i === index ? item * -1 : item))
}

export function generateTerms(key: ActivityNames, difficultyLevel: number, taskHistory: number[]): number[] {
  const { termsCount, ranges } = getRanges(key, difficultyLevel)
  const terms = range(termsCount).map(() => randomIntFromChoices(ranges, taskHistory))

  // Ensure that we have at least 1 negative term
  const firstTerm = terms[0] * -1
  const restOfTerms = terms.slice(1).map((elem) => (Math.random() > 0.5 ? elem * -1 : elem))

  return shuffle([firstTerm, ...restOfTerms])
}

export function addParenthesis(terms: number[]): string[] {
  const firstTerm = terms[0]
  const restOfTerms = terms.slice(1).map((elem) => (elem < 0 ? `(${elem})` : elem.toString()))
  return [firstTerm.toString(), ...restOfTerms]
}
